<template lang="html">
    <div class="z-date" v-bind:class="classes" ref="component">
        <label v-if="label">
            <span v-html="label"></span>
            <span v-if="required"> *</span>
        </label>
        <date-picker
            v-model="val"
            v-bind:format="$props.format"
            v-bind:type="$props.type"
            clearable
            confirm confirm-text="Сохранить" 
            v-bind:disabled="$props.disabled"
            v-on:change="onChange"
            v-bind:placeholder="$props.placeholder"
        >
            <template slot="footer" v-if="$props.reset">
                <button type="button" class="mx-btn mx-datepicker-btn-confirm z-date__reset" @click="onReset">{{ $props.resetText }}</button>
            </template>
        </date-picker>
        <span class="z-error" v-if="$props.error">{{$props.error}}</span>
    </div>
</template>
<script>
    import ZInput from '@/components/ZInput';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/ru';

    export default {
        name: 'z-date',
        components: {ZInput, DatePicker},
        props: {
            value: {
                type: [String, Number, Boolean, Date],
                default: () => ''
            },
            placeholder: {
                type: String,
                default: null
            },
            error: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            inline: {
                type: Boolean,
                default: false
            },
            format: {
                type: String,
                default: 'DD.MM.YYYY'
            },
            type: {
                type: String,
                default: 'date'
            },
            returnString: {
                type: Boolean,
                default: true
            },
            dirty: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: false
            },
            reset: {
                type: Boolean,
                default: false
            },
            resetText: {
                type: String,
                default: 'Сбросить'
            },
        },
        data() {
            return {
                isDirty: false,
                val: null,
                calendar: null,
                calendarClickListener: null,
                componentClickListener: null,
            }
        },
        created() {
            if (this.$props.value) this.getDatetimeFromProp(this.$props.value);
            this.listeners();
        },
        watch: {
            'val'(value) {
                if (!value) return;
                let result = null;
                if (this.$props.type.toUpperCase() === 'DATE') {
                    result = new Date(value);
                    result.setHours(0,0,0,0); //Если формат только дата - ставим таймзону в ноль, чтобы дата не менялась в зависимости от часового пояса
                }
                else result = value;
                this.$emit('input', result);
            },
            'value'(value, newVal) {
                if (value && value != newVal) this.getDatetimeFromProp(value);
            },
            '$props.dirty'(val) {
                if (val && this.isDirty !== val) this.emitDirty();
            }
        },
        computed: {
            classes() {
                return {
                    'inline':    this.inline,
                    'has-error': this.error && this.error.length,
                    'is-dirty':  this.isDirty,
                    'light':     this.$props.light
                }
            }
        },
        methods: {
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            },
            getDatetimeFromProp(newValue) {
                let value = null;
                if (this.$props.type.toUpperCase() === 'DATE') {
                    value = new Date(newValue);
                    value.setHours(0,0,0,0); //Если формат только дата - ставим таймзону в ноль, чтобы дата не менялась в зависимости от часового пояса
                    if (!this.val || this.val === null || value.getTime() != this.val.valueOf()) this.val = value;
                } else {
                    value = this.moment(newValue);
                    if (!this.val || this.val === null || value.valueOf() != this.val.valueOf()) this.val = value.toDate();
                }
            },
            /**
             * Если компонент используется в выпадающем меню или в popup
             * то при выборе даты оно скрывается (т.к. происходит клик вне окна)
             * Поэтому нужен этот код чтобы меню не скрывалось в момент выбора даты
             */
            listeners() {
                this.$nextTick(() => {
                    this.calendarClickListener  = e => e.stopPropagation();
                    this.componentClickListener = e => {
                        if (
                            (!this.calendar || !this.$refs.component) ||
                            (this.calendar && this.$refs.component && !this.calendar.contains(e.target) && !this.$refs.component.contains(e.target))
                        ) {
                            document.removeEventListener('click', this.calendarClickListener, false);
                            document.removeEventListener('click', this.componentClickListener, false);
                            this.calendar = false;
                        }
                    };
                    document.addEventListener('click', this.componentClickListener);

                    if (this.$refs.component) this.$refs.component.addEventListener('click', e => {
                        e.stopPropagation();
                        this.$nextTick(() => {
                            this.calendar = document.querySelector('.mx-datepicker-main'); 
                            if (this.calendar) this.calendar.addEventListener('click', this.calendarClickListener);
                        });
                    });
                });
            },
            onChange() {
                this.emitDirty();
            },
            onReset() {
                this.val = null;
                this.$emit('input', null);
            }
        }    
    }
</script>
<style lang="sass">
    .mx-datepicker-popup
        .mx-datepicker-footer
            display: flex
            align-items: center
            justify-content: space-between
        .mx-btn.z-date__reset
            margin-right: 10px
    .z-date
        margin: 4px 0 10px 0
        width: 100%
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding: 8px 0 0
            color: #ff1744
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            font-weight: 500
            line-height: 12px
            transition: .4s cubic-bezier(.25,.8,.25,1)
            transition-duration: .3s
            z-index: 5
            resize: none
            margin-bottom: 10px
            span
                color: #D66565
        input
            display: block
            line-height: 16px
            padding: 7px 10px
            border: none
            background: #F1F1F1
            outline: none
            color: #000
            font-weight: 400
            height: 26px
            width: 100%
            position: relative
            z-index: 10
            resize: none
            overflow: hidden
            font: normal 12px Roboto
            border-radius: 0
            box-shadow: none

        &.light
            input
                background: var(--color-secondary-100)
                color: var(--color-secondary-900)

        .mx-datepicker
            width: 100%
            i
                z-index: 20

        &.has-error
            input
                background: rgba(214, 101, 101, 0.1)
                border: 1px solid #D66565
        &.inline
            display: flex
            align-items: center
            label
                width: 40%
                flex: 0 0 40%
                padding-right: 8px
                margin: 0
    .z-date.is-dirty
        label
            color: #2196f3
</style>


// WEBPACK FOOTER //
// ZDate.vue?021e498b